// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PauseCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/PauseCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var PauseCircleOutlined = function PauseCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleOutlinedSvg
  }));
};

PauseCircleOutlined.displayName = 'PauseCircleOutlined';
export default React.forwardRef(PauseCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PauseCircleOutlined.js
// module id = 1541
// module chunks = 0